// Keyless geocoding helpers (Photon/OSM) shared by the address autocomplete.
export const PHOTON = "https://photon.komoot.io";
// Bias suggestions toward Montréal (does not restrict other results)
export const BIAS = { lat: 45.5017, lon: -73.5673 };

// IATA airport shortcuts so typing "YUL" surfaces the airport immediately (keyless).
const AIRPORTS = {
  YUL: { name: "Montréal-Pierre Elliott Trudeau International Airport (YUL)", city: "Dorval", province: "QC", country: "Canada", lat: 45.4706, lng: -73.7408 },
  YMX: { name: "Montréal-Mirabel International Airport (YMX)", city: "Mirabel", province: "QC", country: "Canada", lat: 45.6795, lng: -74.0387 },
  YHU: { name: "Montréal Saint-Hubert Airport (YHU)", city: "Longueuil", province: "QC", country: "Canada", lat: 45.5175, lng: -73.4169 },
  YQB: { name: "Québec City Jean Lesage International Airport (YQB)", city: "Québec", province: "QC", country: "Canada", lat: 46.7911, lng: -71.3933 },
  YOW: { name: "Ottawa Macdonald-Cartier International Airport (YOW)", city: "Ottawa", province: "ON", country: "Canada", lat: 45.3225, lng: -75.6692 },
  YYZ: { name: "Toronto Pearson International Airport (YYZ)", city: "Mississauga", province: "ON", country: "Canada", lat: 43.6777, lng: -79.6248 },
  YTZ: { name: "Billy Bishop Toronto City Airport (YTZ)", city: "Toronto", province: "ON", country: "Canada", lat: 43.6275, lng: -79.3962 },
};

export function airportPlace(code) {
  const a = AIRPORTS[code];
  if (!a) return null;
  return {
    placeName: a.name, formattedAddress: `${a.name}, ${a.city}, ${a.province}, ${a.country}`,
    streetNumber: null, street: null, city: a.city, province: a.province, postalCode: null,
    country: a.country, latitude: a.lat, longitude: a.lng, placeId: `iata-${code}`,
    locationType: "airport", provider: "iata",
  };
}

export function classify(p) {
  const key = p.osm_key, val = p.osm_value, type = p.type;
  if (key === "aeroway" || val === "aerodrome" || val === "airport") return "airport";
  if (key === "tourism" && (val === "hotel" || val === "motel" || val === "guest_house")) return "hotel";
  if (["city", "town", "village", "locality", "municipality"].includes(type)) return "city";
  if (["amenity", "shop", "leisure", "office"].includes(key)) return "business";
  if (p.housenumber || p.street) return "address";
  return "place";
}

export function toPlace(f) {
  const p = f.properties || {};
  const [lng, lat] = f.geometry.coordinates;
  const line1 = [p.housenumber, p.street].filter(Boolean).join(" ");
  const primary = p.name || line1 || p.city || p.state || p.country || "";
  const parts = [line1 && line1 !== primary ? line1 : null, p.city || p.district, p.state, p.postcode, p.country];
  const formatted = [primary, ...parts].filter(Boolean).filter((v, i, a) => a.indexOf(v) === i).join(", ");
  return {
    placeName: primary,
    formattedAddress: formatted,
    streetNumber: p.housenumber || null,
    street: p.street || null,
    city: p.city || p.district || null,
    province: p.state || null,
    postalCode: p.postcode || null,
    country: p.country || null,
    latitude: lat,
    longitude: lng,
    placeId: `${p.osm_type || ""}${p.osm_id || ""}` || `${lat},${lng}`,
    locationType: classify(p),
    provider: "osm",
  };
}

// Rank Québec / Canada results first (does not remove others).
export function rank(places) {
  const score = (pl) => (pl.province === "QC" ? 0 : 2) + (pl.country === "Canada" ? 0 : 1);
  return [...places].sort((a, b) => score(a) - score(b));
}
